"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent InputLabel
var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({}, theme.typography.body2, {
      lineHeight: '18px',
      color: theme.palette.neutral.main,
      position: 'inherit',
      transform: 'inherit',
      marginBottom: 2,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      },
      display: 'flex',
      alignItems: 'baseline'
    }),
    optional: (0, _objectSpread2.default)({}, theme.typography.caption, {
      marginLeft: 4,
      color: theme.palette.neutral.main
    }),
    focused: {},
    error: {}
  };
};

/**
 * Label pour champs de formulaire
 */
var HiFormLabel = /*#__PURE__*/function (_React$PureComponent) {
  function HiFormLabel() {
    (0, _classCallCheck2.default)(this, HiFormLabel);
    return _callSuper(this, HiFormLabel, arguments);
  }
  (0, _inherits2.default)(HiFormLabel, _React$PureComponent);
  return (0, _createClass2.default)(HiFormLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        classNameProp = _this$props.className,
        children = _this$props.children,
        htmlFor = _this$props.htmlFor,
        label = _this$props.label,
        InputLabelProps = _this$props.InputLabelProps,
        required = _this$props.required,
        translations = _this$props.translations,
        focused = _this$props.focused,
        other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "children", "htmlFor", "label", "InputLabelProps", "required", "translations", "focused"]);
      var className = (0, _classnames.default)(classes.root, classNameProp);
      return /*#__PURE__*/_react.default.createElement(_InputLabel.default, (0, _extends2.default)({
        htmlFor: htmlFor,
        className: className,
        focused: focused,
        required: false,
        classes: {
          root: classes.root,
          error: classes.error,
          focused: classes.focused
        }
      }, InputLabelProps, other), label, !required && /*#__PURE__*/_react.default.createElement("span", {
        className: classes.optional
      }, " ", translations.optional), children);
    }
  }]);
}(_react.default.PureComponent);
HiFormLabel.defaultProps = {
  required: true,
  translations: {
    optional: 'optional'
  }
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiFormLabel'
})(HiFormLabel);